import { render, staticRenderFns } from "./JournalEventDetail.vue?vue&type=template&id=d96813fe&scoped=true"
import script from "./JournalEventDetail.vue?vue&type=script&lang=js"
export * from "./JournalEventDetail.vue?vue&type=script&lang=js"
import style0 from "./JournalEventDetail.vue?vue&type=style&index=0&id=d96813fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d96813fe",
  null
  
)

export default component.exports